module.exports = __webpack_public_path__ + "static/media/right-active-carosul.d26cdf76.svg";